/* tslint:disable */
/* eslint-disable */
export enum Country {
  Us = 'US',
  Mx = 'MX'
}
